import React from 'react'
import { useFieldArray } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useDispatch } from 'react-redux'
import { useControlledForm, useFormApiError, useFormReset } from 'hooks'
import { mapInternalStateToPayload } from './actions'
import { COMPETENCIES_FIELD, getDefaultValues } from './model'
import { getSchema } from './schema'
import { toTemplatesCreator } from 'ducks/router'

export const useCreateInterviewTemplateForm = handlers => {
  const { onConfirm } = handlers

  const [apiError, setApiError] = React.useState(null)
  const [shouldReset, setShouldReset] = React.useState(false)

  const defaultValues = getDefaultValues()
  const schema = getSchema()
  const dispatch = useDispatch()

  const handlePostSuccessAction = React.useCallback(
    response => {
      setShouldReset(true)

      dispatch(
        toTemplatesCreator({
          tab: 'interviews',
          uuid: response.id,
        }),
      )
    },
    [setShouldReset],
  )

  const handleFormData = React.useCallback(
    data => {
      const payload = mapInternalStateToPayload({ ...data })

      onConfirm(payload, {
        onFailureAction: setApiError,
        postSuccessAction: handlePostSuccessAction,
      })
    },
    [handlePostSuccessAction, onConfirm, setApiError],
  )

  const {
    control,
    formState,
    handleFormApiError,
    handleFormReset,
    handleFormSubmit,
    watch,
    isDirtyOrInvalid,
  } = useControlledForm({
    defaultValues,
    resolver: yupResolver(schema),
    handleFormData,
  })

  const { fields } = useFieldArray({ control, name: COMPETENCIES_FIELD })

  useFormApiError({ apiError }, handleFormApiError)
  useFormReset({ shouldReset }, handleFormReset)

  return {
    state: { control, competencies: { fields }, formState, isDirtyOrInvalid },
    handlers: { handleFormReset, handleFormSubmit, watch },
  }
}
